(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    'use strict';

    /* ── Nav scroll backdrop ── */
    var nav = document.getElementById('mainNav');
    if (nav) {
      var tick = function () { nav.classList.toggle('scrolled', window.scrollY > 20); };
      window.addEventListener('scroll', tick, { passive: true });
      tick();
    }

    /* ── Mobile drawer ── */
    var toggle = document.getElementById('navToggle');
    var drawer = document.getElementById('navDrawer');
    if (toggle && drawer) {
      var openDrawer = function () {
        drawer.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var bars = toggle.querySelectorAll('span');
        bars[0].style.transform = 'translateY(6px) rotate(45deg)';
        bars[1].style.opacity   = '0';
        bars[2].style.transform = 'translateY(-6px) rotate(-45deg)';
      };
      var closeDrawer = function () {
        drawer.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        toggle.querySelectorAll('span').forEach(function (b) {
          b.style.transform = '';
          b.style.opacity   = '';
        });
      };
      toggle.addEventListener('click', function () {
        drawer.classList.contains('open') ? closeDrawer() : openDrawer();
      });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeDrawer);
      });
      // Escape closes the drawer and returns focus to the hamburger.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('open')) {
          closeDrawer();
          toggle.focus();
        }
      });
    }

    /* ── Scroll reveal (legacy .reveal — sections may also use the newer
       data-reveal API owned by aumenu-motion.js) ── */
    var revealEls = document.querySelectorAll('.reveal');
    if (revealEls.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
        );
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('visible'); });
      }
    }

    /* ── Bilingual toggle ──
       Source of truth precedence:
       1. localStorage 'au-lang' (so a user's choice persists across navigation
          even when internal links don't preserve the /fr locale prefix).
       2. The <html lang="…"> attribute set by Shopify based on request.locale.
       3. Default 'fr'. */
    function updatePlaceholders(lang) {
      document.querySelectorAll('[data-ph-fr][data-ph-en]').forEach(function (el) {
        el.placeholder = lang === 'en' ? el.dataset.phEn : el.dataset.phFr;
      });
    }
    function setLang(lang) {
      var html = document.documentElement;
      html.classList.remove('lang-fr', 'lang-en');
      html.classList.add('lang-' + lang);
      // Update the fallback span toggle (single-locale stores)
      document.querySelectorAll('.lang-toggle__opt[data-lang]').forEach(function (opt) {
        opt.classList.toggle('active', opt.dataset.lang === lang);
      });
      // Update the Markets form button active state so it visually matches
      // the actually-displayed language even when localStorage overrides URL.
      document.querySelectorAll('.lang-toggle button[name="locale_code"]').forEach(function (btn) {
        var v = (btn.value || '').toLowerCase().slice(0, 2);
        btn.classList.toggle('active', v === lang);
        btn.setAttribute('aria-current', v === lang ? 'true' : 'false');
      });
      updatePlaceholders(lang);
      try { localStorage.setItem('au-lang', lang); } catch (e) {}
    }
    var saved = null;
    try { saved = localStorage.getItem('au-lang'); } catch (e) {}
    var initialLang = saved;
    if (initialLang !== 'fr' && initialLang !== 'en') {
      var htmlLang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
      initialLang = (htmlLang === 'fr' || htmlLang === 'en') ? htmlLang : 'fr';
    }
    setLang(initialLang);
    // Handler for the fallback span toggle (single-locale stores) —
    // click plus keyboard (the spans carry role="button" + tabindex="0").
    document.querySelectorAll('.lang-toggle__opt[data-lang]').forEach(function (opt) {
      opt.addEventListener('click', function () { setLang(opt.dataset.lang); });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          setLang(opt.dataset.lang);
        }
      });
    });
    // Handler for the Markets localization form buttons.
    // We intercept the form submission entirely. The lang toggle is driven
    // purely by localStorage + class swap — no page reload, no flicker.
    document.querySelectorAll('.lang-toggle button[name="locale_code"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var v = (btn.value || '').toLowerCase().slice(0, 2);
        if (v === 'fr' || v === 'en') setLang(v);
      });
    });
    // Also stop the localization form from submitting on Enter key.
    document.querySelectorAll('form.lang-toggle').forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  /* Password gate — namespaced and guarded: this bundle is aggregated into
     the site-wide script, so exit immediately anywhere but the gate. */
  (function () {
    var stage = document.querySelector('[data-pw-stage]');
    if (!stage) return;

    var docEl = document.documentElement;

    /* Language — same mechanism as the storefront (html.lang-* classes +
       localStorage "au-lang"), so the choice made here carries through the
       gate. Migrates the legacy "aumenu_lang" key if present. */
    var lang = null;
    try {
      lang = localStorage.getItem('au-lang');
      if (lang !== 'fr' && lang !== 'en') {
        var legacy = localStorage.getItem('aumenu_lang');
        if (legacy === 'fr' || legacy === 'en') lang = legacy;
      }
    } catch (e) {}
    if (lang !== 'fr' && lang !== 'en') {
      lang = docEl.classList.contains('lang-en') ? 'en' : 'fr';
    }

    function setLang(l) {
      docEl.classList.remove('lang-fr', 'lang-en');
      docEl.classList.add('lang-' + l);
      docEl.setAttribute('lang', l);
      try { localStorage.setItem('au-lang', l); } catch (e) {}
      var opts = stage.querySelectorAll('.pw-lang__opt');
      for (var i = 0; i < opts.length; i++) {
        opts[i].setAttribute(
          'aria-pressed',
          opts[i].getAttribute('data-lang') === l ? 'true' : 'false'
        );
      }
    }

    setLang(lang);

    var opts = stage.querySelectorAll('.pw-lang__opt');
    for (var i = 0; i < opts.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          setLang(btn.getAttribute('data-lang'));
        });
      })(opts[i]);
    }

    /* Early-access disclosure — Shopify re-renders the page with form.errors
       after a wrong code; reopen the panel so the message is visible. */
    var code = document.getElementById('pw-code');
    if (code && code.querySelector('[data-pw-code-error]')) {
      code.setAttribute('open', '');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-reels"] && !Shopify.designMode) return;
  try {
    
/* Social reels — in-viewport playback.
   Plays a reel only while ~a third of it is visible AND motion is
   allowed AND the tab is visible; otherwise it rests on its first
   frame (preload="metadata" = poster look). No IntersectionObserver
   support → reels simply stay paused. */
(function () {
  var vids = document.querySelectorAll('[data-social-reels] video[data-reel]');
  if (!vids.length) return;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function isReduced() {
    return !!(mq && mq.matches);
  }

  function tryPlay(v) {
    if (isReduced() || document.hidden) return;
    if (v.getAttribute('data-inview') !== 'true') return;
    v.muted = true;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function refreshAll() {
    for (var i = 0; i < vids.length; i++) {
      if (isReduced() || document.hidden || vids[i].getAttribute('data-inview') !== 'true') {
        if (!vids[i].paused) vids[i].pause();
      } else {
        tryPlay(vids[i]);
      }
    }
  }

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var v = entries[i].target;
      if (entries[i].isIntersecting) {
        v.setAttribute('data-inview', 'true');
        tryPlay(v);
      } else {
        v.setAttribute('data-inview', 'false');
        if (!v.paused) v.pause();
      }
    }
  }, { threshold: 0.3 });

  for (var i = 0; i < vids.length; i++) io.observe(vids[i]);

  if (mq) {
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', refreshAll);
    else if (typeof mq.addListener === 'function') mq.addListener(refreshAll);
  }
  document.addEventListener('visibilitychange', refreshAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tabs = document.querySelectorAll('.terms-nav__tab');
  if (!tabs.length) return;

  function activate(id) {
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-tab') === id) {
        tabs[i].classList.add('active');
        tabs[i].setAttribute('aria-current', 'true');
      } else {
        tabs[i].classList.remove('active');
        tabs[i].removeAttribute('aria-current');
      }
    }
  }

  for (var i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', function () {
      activate(this.getAttribute('data-tab'));
    });
  }

  /* Scrollspy — highlights the part currently in the reading band. */
  if ('IntersectionObserver' in window) {
    var targets = document.querySelectorAll('#conditions, #annulation, #confidentialite, #cookies');
    if (targets.length) {
      var spy = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) activate(entries[j].target.id);
        }
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      for (var k = 0; k < targets.length; k++) spy.observe(targets[k]);
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
